import { ItemID } from "types/common";

export type MatchedProductCount = { id: ItemID; count: number };

type ProductWithBrand = { id: ItemID; name: string; brand?: { id: ItemID; name?: string } };

export type MatchedBrand = {
  id: ItemID;
  name: string;
  rowCount: number;
  products: { id: ItemID; name: string; rowCount: number }[];
};

const byName = (a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name);

// Turns the matched_item facet's row count per product into the panel's brand list:
// each brand gets the total of its products' rows and the list of those products, both sorted by name
export const groupMatchedProductsByBrand = (
  counts: MatchedProductCount[],
  products: ProductWithBrand[]
): MatchedBrand[] => {
  const productsById = new Map(products.map((product) => [product.id, product]));
  const brandsById = new Map<ItemID, MatchedBrand>();

  counts.forEach(({ id, count }) => {
    const product = productsById.get(id);
    if (!product?.brand) return;

    const { id: brandId, name: brandName } = product.brand;
    const brand = brandsById.get(brandId) || { id: brandId, name: brandName || brandId, rowCount: 0, products: [] };
    brand.rowCount += count;
    brand.products.push({ id, name: product.name, rowCount: count });
    brandsById.set(brandId, brand);
  });

  return Array.from(brandsById.values())
    .map((brand) => ({ ...brand, products: brand.products.sort(byName) }))
    .sort(byName);
};
